import { createContext, useContext, useState } from "react";

const CurrentClassContext = createContext<{
  currentClass: any;
  setCurrentClass: React.Dispatch<React.SetStateAction<string[]>>;
  selectedClassNote: any;
  setSelectedClassNote: React.Dispatch<React.SetStateAction<any>>;
  selectedClassClassement: any;
  setSelectedClassClassement: React.Dispatch<React.SetStateAction<any>>;
}>({
  currentClass: null,
  setCurrentClass: () => {},
  selectedClassNote: null,
  setSelectedClassNote: () => {},
  selectedClassClassement: null,
  setSelectedClassClassement: () => {},
});

export const CurrentClassProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [currentClass, setCurrentClass] = useState<any>();
  const [selectedClassNote, setSelectedClassNote] = useState<any>();
  const [selectedClassClassement, setSelectedClassClassement] = useState<any>();

  return (
    <CurrentClassContext.Provider
      value={{
        currentClass,
        setCurrentClass,
        selectedClassNote,
        setSelectedClassNote,
        selectedClassClassement,
        setSelectedClassClassement,
      }}
    >
      {children}
    </CurrentClassContext.Provider>
  );
};

// hook personnalisé pour utiliser le contexte plus facilement
export const useCurrentClass = () => {
  const context = useContext(CurrentClassContext);
  if (!context) {
    throw new Error(
      "useCurrentClass must be used within a CurrentClassProvider",
    );
  }
  return context;
};
